import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import PublicFooter from '../components/PublicFooter';
import './PrivacyPolicy.css';

export default function TermsOfService() {
  return (
    <div className="privacy-app">
      <PublicNavbar />

      <main className="privacy-page">
        <div className="privacy-container">

          <header className="privacy-header">
            <p className="privacy-eyebrow">Querely — by Inqlect Technologies Pvt Ltd</p>
            <h1 className="privacy-title">Terms of Service</h1>
            <p className="privacy-meta">Last updated: August 2026</p>
          </header>

          <div className="privacy-body">

            <section className="privacy-section">
              <h2>Agreement</h2>
              <p>
                By accessing Querely, you and your organisation agree to these Terms with
                Inqlect Technologies Pvt Ltd, Bengaluru, India.
              </p>
            </section>

            <section className="privacy-section">
              <h2>The Service</h2>
              <p>
                Querely is an AI-powered assistant enabling authorised users to query SAP
                S/4HANA and ECC systems in natural language via standard OData APIs.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Access and accounts</h2>
              <p>
                Access is granted per organisation under a separate commercial agreement.
                Users are provisioned by the Tenant administrator and are responsible for
                the confidentiality of their credentials. InqLect may suspend access for
                misuse or non-payment.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Acceptable use</h2>
              <p>Users may not:</p>
              <ul>
                <li>Attempt to access SAP data beyond their authorised credentials</li>
                <li>Reverse engineer or copy the application</li>
                <li>Transmit malicious code</li>
                <li>Share credentials with unauthorised persons</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>SAP connectivity</h2>
              <p>
                Querely connects via OData credentials provided by your organisation.
                Your organisation is responsible for appropriate SAP authorisations.
                InqLect does not store or modify SAP transactional data.
              </p>
            </section>

            <section className="privacy-section">
              <h2>SAP API Compliance</h2>
              <p>
                <strong>Customer responsibility.</strong> The use of Querely involves
                connecting to the Customer&rsquo;s SAP system via OData APIs. The Customer
                is solely responsible for ensuring that their use of Querely &mdash;
                including the SAP API credentials and OData endpoints they configure
                &mdash; complies with their own SAP licensing agreements, SAP contractual
                terms, and the SAP API Policy as published by SAP SE from time to time
                (including without limitation restrictions on generative AI integration
                and API usage controls).
              </p>
              <p>
                <strong>Published APIs only.</strong> Querely connects exclusively to
                Published OData APIs made available by SAP on the SAP Business
                Accelerator Hub or equivalent product-specific documentation. Querely
                does not access, invoke, or interact with non-published, internal, or
                private SAP APIs. The Customer is responsible for ensuring that the API
                endpoints they configure within Querely are Published APIs within the
                meaning of the SAP API Policy.
              </p>
              <p>
                <strong>Customer&rsquo;s own credentials.</strong> Querely connects to the
                Customer&rsquo;s SAP system using OData credentials provided and managed
                entirely by the Customer. The Customer warrants that they are duly
                authorised to use the SAP APIs they configure within Querely, and that
                such use is permitted under their SAP licence and contractual agreements
                with SAP SE.
              </p>
              <p>
                <strong>InqLect not a party to SAP agreements.</strong> Inqlect
                Technologies Pvt Ltd is not a party to any agreement between the Customer
                and SAP SE. InqLect has no visibility into, and accepts no responsibility
                or liability for, the Customer&rsquo;s compliance with their SAP licensing
                terms, SAP API Policy, or any other obligation owed by the Customer to
                SAP SE. Any enforcement action, suspension, or claim arising from the
                Customer&rsquo;s SAP API usage is solely the Customer&rsquo;s
                responsibility.
              </p>
              <p>
                <strong>Indemnification.</strong> The Customer agrees to indemnify and
                hold harmless Inqlect Technologies Pvt Ltd from any claim, loss, penalty,
                or liability arising from the Customer&rsquo;s non-compliance with the
                SAP API Policy or their SAP licensing agreements in connection with their
                use of Querely.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Data and privacy</h2>
              <p>
                Governed by our{' '}
                <a href="/privacy">Privacy Policy</a> at querely.com/privacy. SAP
                transactional data is never stored. Conversation history and query logs
                are stored on Azure EU infrastructure. Tenant data is isolated.
              </p>
            </section>

            <section className="privacy-section">
              <h2>AI-generated responses</h2>
              <p>
                Responses are based on live SAP data but may not always be complete or
                accurate. Users should verify critical business information directly in
                SAP before acting on it. InqLect is not liable for business decisions made
                based on Querely responses.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Availability</h2>
              <p>
                InqLect targets reasonable uptime but does not guarantee 100%
                availability. InqLect is not liable for downtime caused by Azure, SAP, or
                other third-party services.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Intellectual property</h2>
              <p>
                Querely and all underlying technology remain the sole property of
                Inqlect Technologies Pvt Ltd. Your organisation retains ownership of all
                SAP and business data accessed through Querely.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Limitation of liability</h2>
              <p>
                InqLect&rsquo;s liability shall not exceed the fees paid by the Tenant in
                the three months preceding the claim. InqLect is not liable for indirect,
                consequential, or loss-of-business damages.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Governing law</h2>
              <p>
                Governed by the laws of India. Disputes are subject to the exclusive
                jurisdiction of courts in Bengaluru, Karnataka, India.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Changes</h2>
              <p>
                Tenant administrators will be given 30 days&rsquo; notice via email of any
                changes to these Terms. Continued use constitutes acceptance.
              </p>
            </section>

            <section className="privacy-section privacy-section--contact">
              <h2>Contact</h2>
              <address>
                Inqlect Technologies Pvt Ltd<br />
                Bengaluru, Karnataka, India<br />
                <a href="mailto:info@inqlect.com">info@inqlect.com</a>
              </address>
            </section>

          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
}
